import React from 'react';
import { useTranslation } from 'react-i18next';
import { FooterSection } from './footer/FooterSection';
import { FooterLinksList } from './footer/FooterLinksList';
import { FooterLink } from './footer/FooterLink';
import { ToggleLanguageButton } from './layout/ToggleLanguageButton';
import logoImage from '../images/LOGO.webp';

const Footer = () => {
  const { t } = useTranslation();
  
  const companyLinks = [
    { to: '/about/', labelKey: t('about') }, 
    { to: '/blog/', labelKey: t('blog') },
    { to: '/careers/', labelKey: t('careers') },
    { to: '/contact/', labelKey: t('contact') }
  ];
  
  const resourceLinks = [
    { 
      to: 'https://app.sensorbite.com',
      labelKey: t('demo'),
      external: true 
    },
    {
      to: '/terms/',
      labelKey: t('termsPrivacy')
    },
    {
      to: '/Gender_Equality_Plan_SENSORBITE_EN.pdf',
      labelKey: t('genderEqualityPlan'),
      external: true
    }
  ];
  
  return (
    <footer className="py-12 bg-slate-900 border-t border-slate-800">
      <div className="container mx-auto px-6">
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          
          <div>
            <div className="flex items-center mb-4">
              <img 
                src={logoImage} 
                alt="SensorBite Logo" 
                className="h-8 w-auto"
              />
            </div>
            
            <p className="text-gray-400 mb-4">
              {t('companyDescription')}
            </p>
            
            <ToggleLanguageButton />
          </div>
          
          <FooterSection title={t('company')}>
            <FooterLinksList links={companyLinks} />
          </FooterSection>
          
          <FooterSection title={t('resources')}>
            <FooterLinksList links={resourceLinks} />
          </FooterSection>
        </div>
        
        <FooterLink 
          to="https://www.linkedin.com/company/sensorbite/"
          external={true}
          className="mr-4"
        >
          LinkedIn
        </FooterLink>
        
        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-gray-500">
          
          <p className="text-sm">
            © {new Date().getFullYear()} SENSORBITE. {t('copyrights')}
          </p>
          
          <p className="text-xs mt-2" style={{ fontSize: "8px" }}>
            {t('legalInfo')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export { Footer };